/*
  Carousel arrows for the Curated products block (WonderSkull custom — not part of
  stock Shrine PRO). Loaded only when the block has arrows enabled.

  Deliberately self-contained: it binds to this block's own markup and never touches
  Shrine's slider component, so a vendor update cannot change how the arrows behave.

  End state is derived from the scroll position (scrollLeft vs the max scroll), updated
  on an rAF-throttled scroll listener. This is authoritative — the prev arrow hides the
  moment the list returns to the start — whereas an IntersectionObserver ratio threshold
  could miss a first card that settled a hair short of fully visible (leaving the arrow
  stuck and a gap at the start of the list).
*/
(function () {
  var REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)');

  function init(root) {
    if (root.dataset.cpArrowsReady === 'true') return;

    var list = root.querySelector('.curated-products__list');
    var prev = root.querySelector('[data-cp-prev]');
    var next = root.querySelector('[data-cp-next]');
    if (!list || !prev || !next) return;

    root.dataset.cpArrowsReady = 'true';

    function scrollByPage(direction) {
      // Just under a full viewport, so the card at the edge stays partly visible and
      // reads as continuous rather than as a jump to an unrelated set.
      var amount = list.clientWidth * 0.8 * direction;
      list.scrollBy({
        left: amount,
        behavior: REDUCED_MOTION.matches ? 'auto' : 'smooth'
      });
    }

    prev.addEventListener('click', function () {
      scrollByPage(-1);
    });
    next.addEventListener('click', function () {
      scrollByPage(1);
    });

    function updateEnds() {
      var max = list.scrollWidth - list.clientWidth;
      var x = list.scrollLeft;
      // A 2px tolerance absorbs sub-pixel / scroll-snap rounding so the state is reliable
      // even when a smooth scroll doesn't settle on an exact integer. When nothing
      // overflows (max <= 0) both ends read true, so both arrows stay hidden.
      root.classList.toggle('curated-products--at-start', x <= 2 || max <= 0);
      root.classList.toggle('curated-products--at-end', x >= max - 2 || max <= 0);
    }

    var ticking = false;
    list.addEventListener('scroll', function () {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(function () { ticking = false; updateEnds(); });
      }
    }, { passive: true });
    window.addEventListener('resize', updateEnds, { passive: true });
    // Card images can change scrollWidth after init; recompute once each one loads.
    list.querySelectorAll('img').forEach(function (img) {
      if (!img.complete) img.addEventListener('load', updateEnds, { once: true });
    });
    updateEnds();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('.curated-products').forEach(init);
  }

  initAll();

  // The theme editor swaps section markup in place, which leaves the new copy
  // unbound unless it is initialised again.
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
